import LegalPage from "@/pages/LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      lastUpdated="December 2025"
      testId="privacy-page"
    >
      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">1. Who we are</h2>
      <p>
        Smashed Burger &amp; Bao Boy ("we", "us", "our") operates a take-away food service from
        172 Portland Rd, Hove BN3 5QN. This Privacy Policy explains how we collect, use, and
        protect personal data in compliance with the UK GDPR and the Data Protection Act 2018.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">2. What we collect</h2>
      <p>
        When you contact us directly we may collect your name, telephone number, and email
        address. When you place a delivery order through a third-party platform (e.g. Uber Eats)
        that platform handles your data under its own Privacy Policy; we receive only the order
        information required to fulfil your order.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">3. How we use it</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>To fulfil and deliver your order.</li>
        <li>To respond to enquiries you send us.</li>
        <li>To meet our legal and tax obligations.</li>
        <li>With your consent, to improve the website (analytics) or send marketing.</li>
      </ul>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">4. Lawful basis</h2>
      <p>
        We rely on (a) contract (to fulfil your order), (b) legal obligation, (c) legitimate
        interests in running our business, and (d) your consent for any optional analytics or
        marketing cookies.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">5. Your rights</h2>
      <p>
        You have the right to access, correct, delete, restrict, or object to the processing of
        your personal data, and the right to data portability. You can complain to the ICO at{" "}
        <a className="text-brand-orange hover:underline" href="https://ico.org.uk/" target="_blank" rel="noreferrer">ico.org.uk</a>.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">6. Retention</h2>
      <p>
        We keep personal data only for as long as necessary for the purposes set out above and to
        comply with our legal obligations.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">7. Contact</h2>
      <p>
        For any data-protection question, please contact us at the address and phone number shown
        below.
      </p>
    </LegalPage>
  );
}
